import {
  addCartLineItemsMutation, cartBuyerIdentityMutation,
  cartCreateMutation,
  cartDiscountsUpdateMutation,
  cartGiftCardsMutation,
  getCartQuery,
  removeCartLineItemsMutation, updateCartAttributesMutation, updateCartLineItemsMutation, updateCartNoteMutation
} from "./Shopify/shopify-queries"
import {
  addSelectiveNoScroll,
  authCheck,
  checkSubscriptionStatus,
  deleteCookie,
  extractProductIdFromStoreFrontId,
  getCookie,
  getDiscount,
  isRPlusMembershipActive,
  isRPlusMembershipInactive,
  mapProductsToRewardsPlusDiscount,
  removeNoScroll,
  setCookie,
  vipPreviewTimers
} from "../common/utils"
import appErrorLogger from "../common/DataDogErrorLog"
import {
  storefrontApi
} from "./shopifyAC"
import { formatShopifyCart, formatShopifyProductsResponse } from "./Shopify/helpers"
import { showSpinner, trackDataEvents } from "./appAC"
import config from "../../config"
import {
  defaultCartAttributes,
  filterLineItems, getCartLineItemShippingFee, getShippingItem, isCartLineItemShippingFee,
  isCartLineItemSubscription, mapCartLinesStandardPriceToJson
} from "../cart/helpers"
import ReactHtmlParser from "react-html-parser"
import { getProductsByTagQuery } from "./Shopify/shopify-queries/product"
import { ProductModel } from "../common/ProductModel"
import { Multipass } from "multipass-js"
import axios from "axios"
import { hideVipModalClearCart, showVipModalSoldout } from "./favoritesAC"

const setAxiosInstance = () => {
  const auth_token = getCookie('auth_token');
  const is_b2b = getCookie('is_b2b');
  return axios.create({
    baseURL: `${config.host_rebag_api}/v6/my-account`,
    timeout: is_b2b ? 120000 : 45000,
    headers: {'Authorization': auth_token}
  });
};

export const setShopifyCart = () => async (dispatch, getState) => {
  let cartId = getLocalCartId();
  const isCartOpen = getState().shopifyReducer.isCartOpen;
  const user_profile = getState().myAccountReducer.user_profile;

  dispatch({
    type: 'SHOW_CART_BUSY',
  })

  try {
    const userLastCart = await getUserLastCart();
    let totalTradesAmount = 0;
    if (userLastCart) {
      cartId = userLastCart.storefront_id;
      userLastCart.trade_in_bags.forEach((trade) => {
        totalTradesAmount += trade.prices.instant_trade_in.value;
      });
      dispatch({
        type: 'SET_TRADE_IN_ITEMS',
        payload: userLastCart.trade_in_bags
      })
    }
    let cartObject = await getShopifyCart(cartId);
    console.log('cartObject', cartObject);
    if (cartObject.cart) {
      const tradesAttribute = cartObject.cart.attributes.find(attribute => attribute.key === 'tradesApplied');

      if (!tradesAttribute || parseFloat(tradesAttribute.value) !== totalTradesAmount) {
        const cartAttributes= [...cartObject.cart.attributes.filter(attribute => attribute.key !== 'tradesApplied'), {key: 'tradesApplied', value: `${totalTradesAmount}`}];
        cartObject = await updateCartAttribute(cartId, cartAttributes);
      }
      const {isSubscriptionInCart } = checkSubscriptionStatus(cartObject.cart);
      let { lineItemsDiscountedSubtotal } = ((isSubscriptionInCart || isRPlusMembershipActive(user_profile))) ? mapProductsToRewardsPlusDiscount(cartObject.cart.lines) : {lineItemsDiscountedSubtotal: cartObject.cart.cost.subtotalAmount.amount};
      const existingShippingFeeItem = getCartLineItemShippingFee(cartObject.cart.lines);
      //if the shipping item exists in cart object we need to remove its fee from the subtotal
      if (existingShippingFeeItem) {
        lineItemsDiscountedSubtotal -= existingShippingFeeItem.merchandise.price.amount;
      }
      const shippingItem = getShippingItem(lineItemsDiscountedSubtotal);

      if (getCookie('noShippingProtection')) {
        dispatch({
          type: "SHIPPING_PROTECTION_ITEM",
          payload: null
        })
      } else {
        dispatch({
          type: "SHIPPING_PROTECTION_ITEM",
          payload: shippingItem
        })
      }

      dispatch({
        type: "UPDATE_SHOPIFY_CART",
        payload: {
          cart: cartObject.cart,
          cartCount: filterLineItems(cartObject.cart.lines).length
        }
      })

      if (isCartOpen) {
        addSelectiveNoScroll("no-scroll--cart");
      }
    } else {
      deleteCookie('cartId');
    }
  } catch (error) {
    appErrorLogger('get shopify cart', error);
  }
  finally {
    dispatch({
      type: 'HIDE_CART_BUSY',
    })
  }
}

export const addToShopifyCart = (product) => (dispatch, getState) => {
  return new Promise (async (resolve) => {
    dispatch({type: "SHOW_SPINNER"});
    const variant_id = product.product_variant.id;
    const user_profile = getState().myAccountReducer.user_profile;
    let cartId = getLocalCartId();
    const userLastCart = await getUserLastCart();

    if (userLastCart) {
      cartId = userLastCart.storefront_id;
    }
    const cartLineItems = [{
      attributes: [],
      merchandiseId: variant_id,
      quantity: 1
    }];

    dispatch({
      type: "SET_GFY_ERROR",
      payload: false
    })

    try {
      if (cartId) {
        const addCartItemResponse = await addCartLineItems(cartLineItems, cartId);
        if (addCartItemResponse.userErrors) {
          let cartNote = '';
          if (isRPlusMembershipInactive(user_profile)) {
            cartLineItems.push(config.subscriptions.default);
            cartNote = 'withSubscription';
          }

          const cartResponse = await createCart(cartLineItems, cartNote, defaultCartAttributes, user_profile);
          await saveUserLastCart({
            storefront_id: cartResponse.cart.id,
            checkout_url: cartResponse.cart.checkoutUrl
          })
          setCookie('cartId', cartResponse.cart.id);
          cartId = cartResponse.cart.id;
          dispatch({
            type: 'TOGGLE_CART',
            payload: true
          })
          //I don't know what are these maybe MC knows better
          addSelectiveNoScroll("no-scroll--cart");
          document.getElementById("add-to-cart-button-input").classList.remove("pdp__cart-cta--disabled");
        } else {
          dispatch({
            type: 'TOGGLE_CART',
            payload: true
          })
        }
      } else {
        let cartNote = '';
        if (isRPlusMembershipInactive(user_profile)) {
          cartLineItems.push(config.subscriptions.default);
          cartNote = 'withSubscription';
        }

        const cartResponse = await createCart(cartLineItems, cartNote, defaultCartAttributes, user_profile);
        await saveUserLastCart({
          storefront_id: cartResponse.cart.id,
          checkout_url: cartResponse.cart.checkoutUrl
        })
        setCookie('cartId', cartResponse.cart.id);
        cartId = cartResponse.cart.id;
        dispatch({
          type: 'TOGGLE_CART',
          payload: true
        })
        //I don't know what are these maybe MC knows better
        addSelectiveNoScroll("no-scroll--cart");
        document.getElementById("add-to-cart-button-input").classList.remove("pdp__cart-cta--disabled");
      }
    } catch (error) {
      appErrorLogger('addShopifyCartItem', error);
    } finally {
      trackDataEvents({
        "event_type": "add_to_cart",
        "event_properties": {
          "product_id": extractProductIdFromStoreFrontId(variant_id),
        },
        "ga_event": null
      })
      if (window.gbTracker && product) {
        window.gbTracker.sendAddToCartEvent({
          "cart": {
            "id": cartId,
            "items": [
              {
                "productId": `${product.id}`,
                "title": product.title,
                "price": product.price,
                "quantity": 1,
                "collection": "ProductsProduction",
                "category": product.item_type,
                "sku": `${product.id}`,
              },
            ]
          },
          "searchAttributionToken": getCookie('searchAttributionToken') || '',
          "experiments": [
            {
              "experimentId": "RebagGroupByTest",
              "experimentVariant": 'GroupBy',
            }
          ]
        });
        window.dataLayer.push({
          'event': 'api_provider',
          'type': 'add_to_cart',
          'value': 'GroupBy',
          'non_USD': false,
        });
      }
      dispatch({type: "HIDE_SPINNER"});
      resolve();
    }
  })
}

export const addShopifyCartMultipleItems = (shopify_favorites_list_available, shopify_favorites_list_unavailable=[], newCart=false) => async (dispatch, getState) => {
  dispatch({type: "SHOW_SPINNER"});
  dispatch(hideVipModalClearCart());
  const user_profile = getState().myAccountReducer.user_profile;
  const cart = getState().shopifyReducer.cart;
  let cartId = getLocalCartId();
  const userLastCart = await getUserLastCart();
  if (userLastCart) {
    cartId = userLastCart.storefront_id;
  }
  const cartLineItems = shopify_favorites_list_available.map(product => {
    return {
      attributes: [],
      merchandiseId: product.product_variant.id,
      quantity: 1
    }
  }).filter(product => {
    if (!cart || cart.lines.length === 0) {
      return true;
    } else {
      return !cart.lines.find(line => line.merchandise.id === product.merchandiseId);
    }
  })

  try {
    if (!newCart && cartId) {
      let addCartItemResponse = {userErrors:null};
      if (cartLineItems.length > 0) {
        addCartItemResponse = await addCartLineItems(cartLineItems, cartId);
      }
      if (addCartItemResponse.userErrors) {
        let cartNote = '';
        if (isRPlusMembershipInactive(user_profile)) {
          cartLineItems.push(config.subscriptions.default);
          cartNote = 'withSubscription';
        }

        const cartResponse = await createCart(cartLineItems, cartNote, defaultCartAttributes, user_profile);
        await saveUserLastCart({
          storefront_id: cartResponse.cart.id,
          checkout_url: cartResponse.cart.checkoutUrl
        })
        setCookie('cartId', cartResponse.cart.id);
        dispatch({
          type: 'TOGGLE_CART',
          payload: true
        })
        //I don't know what are these maybe MC knows better
        addSelectiveNoScroll("no-scroll--cart");
        document.getElementById("add-to-cart-button-input").classList.remove("pdp__cart-cta--disabled");
      } else {
        dispatch({
          type: 'TOGGLE_CART',
          payload: true
        })
      }
    } else {
      let cartNote = '';
      if (isRPlusMembershipInactive(user_profile)) {
        cartLineItems.push(config.subscriptions.default);
        cartNote = 'withSubscription';
      }

      const cartResponse = await createCart(cartLineItems, cartNote, defaultCartAttributes, user_profile);
      await saveUserLastCart({
        storefront_id: cartResponse.cart.id,
        checkout_url: cartResponse.cart.checkoutUrl
      })
      setCookie('cartId', cartResponse.cart.id);
      dispatch({
        type: 'TOGGLE_CART',
        payload: true
      })
      //I don't know what are these maybe MC knows better
      addSelectiveNoScroll("no-scroll--cart");
      if (shopify_favorites_list_unavailable.length) {
        removeNoScroll("no-scroll--cart");
        dispatch({type: "CLOSE_CART"});
        dispatch(showVipModalSoldout());
      }
    }
  } catch (error) {
    appErrorLogger('addShopifyCartMultipleItems', error);
  } finally {
    dispatch({type: "HIDE_SPINNER"});
  }
}

export const removeItemFromCart = (lineItem) => async (dispatch, getState) => {
  const user_profile = getState().myAccountReducer.user_profile;
  dispatch({
    type: 'SHOW_CART_BUSY',
  })
  try {
    const cart = getState().shopifyReducer.cart;
    const existingShippingFeeItem = getCartLineItemShippingFee(cart.lines);
    if (cart.lines.length === 2 && existingShippingFeeItem) {
      await removeCartLineItems([existingShippingFeeItem.id], cart.id);
    }
    const updatedCart = await removeCartLineItems([lineItem.id], cart.id);
    const {isSubscriptionInCart } = checkSubscriptionStatus(updatedCart.cart);
    let { lineItemsDiscountedSubtotal } = ((isSubscriptionInCart || isRPlusMembershipActive(user_profile))) ? mapProductsToRewardsPlusDiscount(updatedCart.cart.lines) : {lineItemsDiscountedSubtotal: updatedCart.cart.cost.subtotalAmount.amount};
    //if the shipping item exists in cart object we need to remove its fee from the subtotal
    if (existingShippingFeeItem) {
      lineItemsDiscountedSubtotal -= existingShippingFeeItem.merchandise.price.amount;
    }
    const shippingItem = getShippingItem(lineItemsDiscountedSubtotal);

    if (!getCookie('noShippingProtection')) {
      dispatch({
        type: "SHIPPING_PROTECTION_ITEM",
        payload: shippingItem
      })
    }

    if (user_profile) {
      const {user_gift_card_gfy_total, user_gift_card_total} = getState().myAccountReducer;
      const gfy_min_amount_to_apply = user_profile.gfy_min_dollar_amount;
      const should_show_gfy_error = user_gift_card_gfy_total > 0 && updatedCart.cart.cost.subtotalAmount.amount <= gfy_min_amount_to_apply && user_gift_card_gfy_total === user_gift_card_total;
      if (should_show_gfy_error) {
        dispatch({
          type: "SET_GFY_ERROR",
          payload: true
        })
        dispatch(setWalletAccordion(true));
        await dispatch(removeShopifyCartRebagCreditGiftCards());
      } else {
        dispatch({
          type: "UPDATE_SHOPIFY_CART",
          payload: {
            cart: updatedCart.cart,
            cartCount: filterLineItems(updatedCart.cart.lines).length
          }
        })
      }
    } else {
      dispatch({
        type: "UPDATE_SHOPIFY_CART",
        payload: {
          cart: updatedCart.cart,
          cartCount: filterLineItems(updatedCart.cart.lines).length
        }
      })
    }
  } catch (error) {
    appErrorLogger('removeShopifyCartItem', error);
  } finally {
    dispatch({
      type: 'HIDE_CART_BUSY',
    })
  }
}

export const createCart = (lineItems, checkoutNote, attributes, user_profile) => {
  return new Promise(async (resolve) => {
    const variables = {
      input: {
        lines: lineItems,
        note : checkoutNote || '',
        attributes: attributes || []
      }
    }

    if (user_profile) {
      variables.input.buyerIdentity = {
        email: user_profile.email,
      }
    }

    try {
      const createCartResponse = await storefrontApi(cartCreateMutation, variables);
      const formattedCart = formatShopifyCart(createCartResponse.data.cartCreate.cart, createCartResponse.data.cartCreate.userErrors);
      if (getCookie('noShippingProtection')) {
        deleteCookie('noShippingProtection');
      }
      resolve(formattedCart);
    } catch (error) {
      appErrorLogger('createCart', error);
      resolve({checkoutUrl: '', id: '', lines: {edges: []}});
    }
  })
}

export const handleCartGiftCards = (cartId, giftCards) => {
  return new Promise(async (resolve, reject) => {
    const variables = {
      cartId,
      giftCardCodes: giftCards
    }
    try {
      const cartGiftCardsResponse = await storefrontApi(cartGiftCardsMutation, variables);
      const formattedCart = formatShopifyCart(cartGiftCardsResponse.data.cartGiftCardCodesUpdate.cart, cartGiftCardsResponse.data.cartGiftCardCodesUpdate.userErrors);
      resolve(formattedCart);
    } catch (error) {
      appErrorLogger('addGiftCardsToCart', error);
      reject(error);
    }
  })
}

export const handleCartDiscount = (discountCode, cartId) => {
  return new Promise(async (resolve) => {
    const variables = {
      "cartId": cartId,
      "discountCodes": discountCode ? [discountCode] : []
    }
    if (!cartId) {
      resolve();
    } else {
      try {
        const addCartDiscountResponse = await storefrontApi(cartDiscountsUpdateMutation, variables);
        resolve(formatShopifyCart(addCartDiscountResponse.data.cartDiscountCodesUpdate.cart, addCartDiscountResponse.data.cartDiscountCodesUpdate.userErrors));
      } catch (error) {
        appErrorLogger('handleCartDiscount', error);
        resolve();
      }
    }
  })
}

export const addShopifyCartDiscount = (discountCode = null, updatedCart) => (dispatch, getState) => {
    return new Promise (async (resolve, reject) => {
      dispatch({type: "SHOW_CART_BUSY"});
      const cart = updatedCart || getState().shopifyReducer.cart;
      const cartAttributes = cart && cart.attributes.map((attribute) => {return {key: attribute.key, value: attribute.value}}).filter((attribute) => attribute.key !== 'marketingDiscount') || [];

      try {
        const formattedDiscountResponse = await handleCartDiscount(discountCode, cart.id);
        const {discount} = getDiscount(formattedDiscountResponse.cart.discountAllocations, formattedDiscountResponse.cart.lines);
        const formattedUpdateCartAttribute = await updateCartAttribute(cart.id, [...cartAttributes,
          {
            key: 'marketingDiscount',
            value: `${discount.discountedAmount.amount}`,
          }
        ]);
        if (!updatedCart) {
          dispatch({
            type: "UPDATE_SHOPIFY_CART",
            payload: {
              cart: formattedUpdateCartAttribute.cart,
              cartCount: filterLineItems(formattedUpdateCartAttribute.cart.lines).length
            }
          });
        }

        if(discount.discountedAmount.amount > 0) {
          resolve(formattedUpdateCartAttribute.cart);
        } else {
          reject('The discount code is invalid.');
        }
      } catch (error) {
        const errors = JSON.parse(error);
        if (errors[0].code === 'DISCOUNT_NOT_FOUND') {
          let discountError = errors[0].message;
          if (discountCode.length === 16) {
            if (authCheck()) {
              discountError = ReactHtmlParser("Rebag Credit are now automatically added to your account, you can review your Rebag Credit balance <a href='/my-account/payment'>here</a>");
            } else {
              discountError = 'Please log in to your account to use your Rebag Credit';
            }
          }
          reject(discountError);
        } else if (['This discount has reached its usage limit', 'This discount is not valid anymore', 'Unable to apply this discount code.'].includes(errors[0])){
          reject(errors[0]);
        } else {
          reject(errors[0].message);
          appErrorLogger('Add Shopify Cart Discount ' + discountCode, errors);
        }
      } finally {
        dispatch({type: "HIDE_CART_BUSY"});
      }
    })
}

export const removeShopifyCartDiscount = (reason = "") => async (dispatch, getState) => {
    const cart = getState().shopifyReducer.cart;
    const cartAttributes = cart && cart.attributes.map((attribute) => {return {key: attribute.key, value: attribute.value}}).filter((attribute) => attribute.key !== 'marketingDiscount') || [];

  dispatch({type: "SHOW_CART_BUSY"});
    try {
      await handleCartDiscount(null, cart.id);
      const formattedCart = await updateCartAttribute(cart.id, [...cartAttributes,
        {
          key: 'marketingDiscount',
          value: '0',
        }
      ]);
      dispatch({
        type: "UPDATE_SHOPIFY_CART",
        payload: {
          cart: formattedCart.cart,
          cartCount: filterLineItems(formattedCart.cart.lines).length
        }
      });
    } catch (error) {
      appErrorLogger('Remove Shopify Cart Discount', error);
    } finally {
      dispatch({type: "HIDE_CART_BUSY"});
    }
}

export const getProductsByTag = (tag) => (dispatch, getState) => {
  return new Promise(async (resolve) => {
    const can_see_first_look_items = authCheck() && getCookie("can_see_first_look") === "true";
    const {must_show_navbar_message} = vipPreviewTimers();
    const generalViewProducts = can_see_first_look_items && must_show_navbar_message ? '' : ' AND tag:bc-filter-General View';
    const variables = {
      first: 20,
      query: `tag:${tag} AND available_for_sale:true${generalViewProducts}`,
      sortKey: "CREATED_AT",
      reverse: true
    }
    storefrontApi(getProductsByTagQuery, variables).then(formatShopifyProductsResponse)
      .then(productModels => {
        const init = JSON.parse(localStorage.getItem('init'));
        const selectedCountry = getState().appReducer.selectedCountry;
        const products = [];
        productModels.forEach(model => {
          const mapModel = { ...model };
          const images = [];
          mapModel.images.forEach(image => {
            images.push(image.src)
          });
          mapModel.images = images;
          mapModel.favorites_count = model.favorites_count ? model.favorites_count.value : 0;
          products.push(ProductModel(mapModel, selectedCountry, init));
        })
        resolve(products);
      })
      .catch(error => {
        appErrorLogger('homepage carousels getProductsByTag', error);
        resolve();
      });
  })
}

export const addCartLineItems = (lineItems, cartId) => {
  return new Promise(async (resolve) => {
    const variables = {
      "cartId": cartId,
      "lines": lineItems
    }
    try {
      const addCartLineItemsResponse = await storefrontApi(addCartLineItemsMutation, variables);
      const formattedCart = formatShopifyCart(addCartLineItemsResponse.data.cartLinesAdd.cart, addCartLineItemsResponse.data.cartLinesAdd.userErrors);
      resolve(formattedCart);
    } catch (error) {
      appErrorLogger('addCartLineItems', error);
      resolve();
    }
  })
}

export const removeCartLineItems = (lineItemIds, cartId) => {
  return new Promise(async (resolve) => {
    const variables = {
      "cartId": cartId,
      "lineIds": lineItemIds
    }
    if (!cartId) {
      resolve();
      return;
    }
    try {
      const removeCartLineItemsResponse = await storefrontApi(removeCartLineItemsMutation, variables);
      const formattedCart = formatShopifyCart(removeCartLineItemsResponse.data.cartLinesRemove.cart, removeCartLineItemsResponse.data.cartLinesRemove.userErrors);
      resolve(formattedCart);
    } catch (error) {
      appErrorLogger('removeCartLineItems', error);
      resolve();
    }
  })
}

export const updateCartLineItems = (lineItems, cartId) => {
  return new Promise(async (resolve) => {
    const variables = {
      "cartId": cartId,
      "lines": lineItems
    }
    try {
      const addCartLineItemsResponse = await storefrontApi(updateCartLineItemsMutation, variables);
      const formattedCart = formatShopifyCart(addCartLineItemsResponse.data.cartLinesUpdate.cart, addCartLineItemsResponse.data.cartLinesUpdate.userErrors);
      resolve(formattedCart);
    } catch (error) {
      appErrorLogger('updateCartLineItems', error);
      resolve();
    }
  })
}

export const addRewardsPlusSubscription = () => async (dispatch, getState) => {
  return new Promise(async (resolve) => {
    dispatch({ type: "SHOW_CART_BUSY" });
    const { cart } = getState().shopifyReducer;
    const subscriptionLineItem = [config.subscriptions.default];
    let updatedCart = await addCartLineItems(subscriptionLineItem, cart.id);
    const updatedCartNote = await updateCartNote('withSubscription', cart.id);
    const cartSubscriptionItem = updatedCart.cart.lines.filter(item => isCartLineItemSubscription(item))[0];
    const { lineItemsDiscountedSubtotal } = mapProductsToRewardsPlusDiscount(updatedCart.cart.lines);
    const shippingItem = getShippingItem(lineItemsDiscountedSubtotal);
    if (!getCookie('noShippingProtection')) {
      dispatch({
        type: "SHIPPING_PROTECTION_ITEM",
        payload: shippingItem
      })
    }
    if (cartSubscriptionItem && cartSubscriptionItem.quantity > 1) {
     const updateSubscriptionLineItemQuantity = {
       attributes: cartSubscriptionItem.attributes,
       id: cartSubscriptionItem.id,
       quantity: 1,
       merchandiseId: cartSubscriptionItem.merchandise.id,
       sellingPlanId: cartSubscriptionItem.sellingPlanAllocation?.sellingPlan?.id
     }
     updatedCart = await updateCartLineItems([updateSubscriptionLineItemQuantity], updatedCart.cart.id);
    }

    dispatch({
      type: "UPDATE_SHOPIFY_CART",
      payload: {
        cart: {...updatedCart.cart, note: updatedCartNote.data.cartNoteUpdate.cart.note},
        cartCount: filterLineItems(updatedCart.cart.lines).length
      }
    })
    dispatch({ type: "HIDE_CART_BUSY" });
    resolve();
  })
}

export const removeRewardsPlusSubscription = () => async (dispatch, getState) => {
  return new Promise(async (resolve) => {
    dispatch({ type: "SHOW_CART_BUSY" });
    const cart = getState().shopifyReducer.cart;
    const cartLineItemIds = [];

    cart.lines.forEach(item => {
      if (isCartLineItemSubscription(item)) {
        cartLineItemIds.push(item.id);
      }
    })
    const updatedCart = await removeCartLineItems(cartLineItemIds, cart.id);
    const updatedCartNote = await updateCartNote('noSubscription', cart.id);
    const existingShippingFeeItem = getCartLineItemShippingFee(updatedCart.cart.lines);
    let { lineItemsDiscountedSubtotal } = {lineItemsDiscountedSubtotal: updatedCart.cart.cost.subtotalAmount.amount};
    //if the shipping item exists in cart object we need to remove its fee from the subtotal
    if (existingShippingFeeItem) {
      lineItemsDiscountedSubtotal -= existingShippingFeeItem.merchandise.price.amount;
    }
    const shippingItem = getShippingItem(lineItemsDiscountedSubtotal);
    if (!getCookie('noShippingProtection')) {
      dispatch({
        type: "SHIPPING_PROTECTION_ITEM",
        payload: shippingItem
      })
    }
    dispatch({
      type: "UPDATE_SHOPIFY_CART",
      payload: {
        cart: {...updatedCart.cart, note: updatedCartNote.data.cartNoteUpdate.cart.note},
        cartCount: filterLineItems(updatedCart.cart.lines).length
      }
    })
    dispatch({ type: "HIDE_CART_BUSY" });
    resolve();
  })
}

export const continueToShopifyCheckout = (email, isAlternatePaymentFlowCartId) => async (dispatch, getState) => {
  dispatch({type: "SHOW_CART_BUSY"});
  let cart = getState().shopifyReducer.cart;
  if (isAlternatePaymentFlowCartId) {
    const cartResponse = await getShopifyCart(isAlternatePaymentFlowCartId);
    cart = cartResponse.cart;
  }

  const user_profile = getState().myAccountReducer.user_profile;
  const personalizationTest = user_profile && user_profile.personalization_features  ? "enabled" : "not_qualified";
  const attributesToUpdate = getContinueToCheckoutAttributes(cart, user_profile, personalizationTest);
  const cartSubscriptionItem = cart.lines.filter(item => isCartLineItemSubscription(item))[0];

  await updateCartAttribute(cart.id, attributesToUpdate);
  await dispatch(checkShippingFeeItem(cart, isAlternatePaymentFlowCartId));

  if (cartSubscriptionItem && cartSubscriptionItem.quantity > 1) {
    const updateSubscriptionLineItemQuantity = {
      attributes: cartSubscriptionItem.attributes,
      id: cartSubscriptionItem.id,
      quantity: 1,
      merchandiseId: cartSubscriptionItem.merchandise.id,
      sellingPlanId: cartSubscriptionItem.sellingPlanAllocation?.sellingPlan?.id
    }
    await updateCartLineItems([updateSubscriptionLineItemQuantity], cart.id);
  }

  try {
    if (authCheck()) {
      const customerData = {
        email: getCookie('auth_email'),
        user: getCookie('auth_token'),
      };
      goToCheckoutWithMultipass(cart.checkoutUrl, customerData);
    } else {
      if (cart.buyerIdentity.email === null || cart.buyerIdentity.email !== email && email) {
        await storefrontApi(cartBuyerIdentityMutation, {email});
        goToCheckoutWithMultipass(cart.checkoutUrl, {email});
      } else {
        goToCheckoutWithMultipass(cart.checkoutUrl, {email});
      }
    }
  } catch (error) {
    appErrorLogger('continueToShopifyCheckout', error);
  } finally {
    dispatch({type: "HIDE_CART_BUSY"});
  }
}

export const checkShippingFeeItem = (cart, isAlternatePaymentFlowCartId) => (dispatch, getState) => {
  return new Promise(async (resolve) => {
    const existingShippingFeeItem = getCartLineItemShippingFee(cart.lines);
    const newShippingFeeItem = getState().shopifyReducer.shippingProtectionItem;

    //we already have a shipping protection item in cart which means the user went to checkout and came back to cart
    if (existingShippingFeeItem) {
      //the user opts for shipping protection, but the subtotal is changed so we have a new shipping protection fee
      if (newShippingFeeItem) {
        //the new shipping protection fee is different than the existing shipping protection item in cart so we need
        //to remove the existing one and add the new one
        if (parseFloat(existingShippingFeeItem.merchandise.price.amount) !== newShippingFeeItem.shippingFee) {
          await removeCartLineItems([existingShippingFeeItem.id], cart.id);
          await addCartLineItems([newShippingFeeItem.shopifyObject], cart.id);
        }
        //the user opts for no shipping protection so we need to remove the existing shipping protection item
      } else if (!isAlternatePaymentFlowCartId) {
        await removeCartLineItems([existingShippingFeeItem.id], cart.id);
      }
      resolve();
      //the user opts for shipping protection
    } else if (newShippingFeeItem) {
      await addCartLineItems([newShippingFeeItem.shopifyObject], cart.id);
      resolve();
    } else {
      resolve();
    }
  })
}

const getContinueToCheckoutAttributes = (cart, user_profile, personalizationTest) => {
  const filterGeneralAttributes = ['tradeTaxAdjustment', 'cartId', 'isUserRPlus', 'cartLinesStandardPrices', 'rPlusAndItems', 'ppid', 'isUserB2b', 'checkout_type', 'totalRPlusDiscount', 'groupByVisitorId', 'groupBySessionId', 'personalization_test', 'plp_update_test'];
  const cartAttributes = cart && cart.attributes.map((attribute) => {return {key: attribute.key, value: attribute.value}}).filter((attribute) => !filterGeneralAttributes.includes(attribute.key)) || [];
  const userIsRPlus = isRPlusMembershipActive(user_profile);
  const isUserB2b = user_profile && user_profile.is_b2b;
  const {isSubscriptionInCart, subscriptionOnlyCart} = checkSubscriptionStatus(cart);
  const {totalRewardsDiscount} = mapProductsToRewardsPlusDiscount(cart.lines);

  const attributesToUpdate = [...cartAttributes,
    {
      key: 'tradeTaxAdjustment',
      value: '0',
    },
    {
      key: 'cartId',
      value: cart.id,
    },
    {
      key: 'isUserRPlus',
      value: `${userIsRPlus}`
    },
    {
      key: 'checkout_type',
      value: 'web'
    },
    {
      key: 'isUserB2b',
      value: isUserB2b ? 'true' : 'false'
    },
    {
      key: 'groupByVisitorId',
      value: `${getCookie('gbi_visitorId')}`
    },
    {
      key: 'groupBySessionId',
      value: `${getCookie('gbi_sessionId')}`
    },
    {
      key: 'personalization_test',
      value: `${personalizationTest}`
    },
  ]

  //this attribute is needed to calc the R+ discount in checkout + BE needs it for sales data
  if (isSubscriptionInCart || userIsRPlus) {
    const cartLinesStandardPrices = mapCartLinesStandardPriceToJson(cart.lines);
    attributesToUpdate.push(
      {
        key: 'cartLinesStandardPrices',
        value: cartLinesStandardPrices
      },
      {
        key: 'totalRPlusDiscount',
        value: `${totalRewardsDiscount}`
      }
      )
  } else {
    attributesToUpdate.push(
      {
        key: 'cartLinesStandardPrices',
        value: JSON.stringify({})
      },
      {
        key: 'totalRPlusDiscount',
        value: '0'
      }
    )
  }

  //this attribute is needed for various functions in checkout
  if (isSubscriptionInCart && !subscriptionOnlyCart) {
    attributesToUpdate.push({
      key: 'rPlusAndItems',
      value: 'true'
    })
  } else {
    attributesToUpdate.push({
      key: 'rPlusAndItems',
      value: 'false'
    })
  }

  if (window._pp && window._pp.ppid) {
    attributesToUpdate.push(
      {
        key: 'ppid',
        value: `${window._pp.ppid}`
      },
    )
  }
  return attributesToUpdate
}

export const removeShopifyCartItemBulk = (lineItems, callback) => async (dispatch, getState) => {
  const cart = getState().shopifyReducer.cart;
  const lineItemsToRemove = [];
  lineItems.forEach((lineItem) => {
    lineItemsToRemove.push(lineItem.id);
  })
  dispatch({
    type: 'SHOW_CART_BUSY',
  })
  try {
    const updatedCart = await removeCartLineItems(lineItemsToRemove, cart.id);
    dispatch({
      type: "UPDATE_SHOPIFY_CART",
      payload: {
        cart: updatedCart.cart,
        cartCount: filterLineItems(updatedCart.cart.lines).length
      }
    })
  } catch (error) {
    appErrorLogger('removeShopifyCartItemBulk', error);
  } finally {
    dispatch({
      type: 'HIDE_CART_BUSY',
    })
    callback();
  }
}

export const toggleApplyPointsToShopifyCart = (applied_value, wallet) => {
  return async (dispatch, getState) => {
    const cart = getState().shopifyReducer.cart;
    const cartAttributes = cart && cart.attributes.map((attribute) => {return {key: attribute.key, value: attribute.value}}).filter((attribute) => attribute.key !== 'pointsApplied' && attribute.key !== 'numberOfPointsApplied') || [];

    dispatch({type: 'SHOW_CART_BUSY'});
    try {
      if (applied_value > 0) {
        const updatedCart = await updateCartAttribute(cart.id, [...cartAttributes,
          {
            key: 'pointsApplied',
            value: '0',
          },
          {
            key: 'numberOfPointsApplied',
            value: '0',
          }
        ]);
        dispatch({
          type: "UPDATE_SHOPIFY_CART",
          payload: {
            cart: updatedCart.cart,
            cartCount: filterLineItems(updatedCart.cart.lines).length
          }
        })
        dispatch({type: 'HIDE_CART_BUSY'});
      } else {
        if (wallet.applyPoints) {
          const updatedCart = await updateCartAttribute(cart.id, [...cartAttributes,
            {
              key: 'pointsApplied',
              value: `${getState().myAccountReducer.user_profile.loyalty_points_value}`,
            },
            {
              key: 'numberOfPointsApplied',
              value: `${getState().myAccountReducer.user_profile.points}`,
            }
          ]);
          dispatch({
            type: "UPDATE_SHOPIFY_CART",
            payload: {
              cart: updatedCart.cart,
              cartCount: filterLineItems(updatedCart.cart.lines).length
            }
          })
        }
      }
    } catch (error) {
      appErrorLogger('Toggle Apply Points To Shopify Cart', error);
    } finally {
      dispatch({type: 'HIDE_CART_BUSY'});
    }
  }
}

export const toggleApplyRebagCreditToShopifyCart = (applied_value) => async (dispatch) => {
  dispatch({type: 'SHOW_CART_BUSY'});
  try {
    if (applied_value) {
      await dispatch(removeShopifyCartRebagCreditGiftCards());
    } else {
      await dispatch(addShopifyCartRebagCreditGiftCards());
    }
  } catch (error) {
    appErrorLogger('Toggle Apply Rebag Credit To Shopify Cart', error);
  } finally {
    dispatch({type: 'HIDE_CART_BUSY'});
  }
}

export const toggleApplyRewardsCreditToShopifyCart = (isRewardsApplied) => {
  return async (dispatch) => {
    dispatch({type: 'SHOW_CART_BUSY'});
    try {
      if (isRewardsApplied) {
        await dispatch(removeShopifyCartRewardsGiftCards());
      } else {
        await dispatch(addShopifyCartRewardsGiftCards());
      }
    } catch (error) {
      appErrorLogger('Toggle Apply Rewards Credit To Shopify Cart', error);
    } finally {
      dispatch({type: 'HIDE_CART_BUSY'});
    }
  }
}

export const toggleApplySellerFundsToShopifyCart = (isSellerFundsApplied) => async dispatch => {
  dispatch({type: 'SHOW_CART_BUSY'});
  try {
    if (isSellerFundsApplied) {
      await dispatch(removeShopifyCartSellerFundsGiftCards());
    } else {
      await dispatch(addShopifyCartSellerFundsGiftCards());
    }
  } catch (error) {
    appErrorLogger('Toggle Apply Seller Funds To Shopify Cart', error);
  } finally {
    dispatch({type: 'HIDE_CART_BUSY'});
  }
}

export const toggleApplyWalletToShopifyCart = (total_applied_gift_cards, appliedDiscount, wallet) => {
  return async (dispatch, getState) => {
    dispatch({type: 'SHOW_CART_BUSY'});
    const cart = getState().shopifyReducer.cart;
    const user_profile = getState().myAccountReducer.user_profile;
    const {wallet_gift_cards, rewards_gift_cards, rebag_credit_gift_cards} = user_profile;
    const cartAttributes = cart && cart.attributes.map((attribute) => {return {key: attribute.key, value: attribute.value}}).filter((attribute) => attribute.key !== 'pointsApplied' && attribute.key !== 'numberOfPointsApplied') || [];
    const {rebagCredit, walletCash, rewardsCredit} = total_applied_gift_cards;
    try {
      if (rebagCredit > 0 || walletCash > 0 || rewardsCredit > 0 || appliedDiscount.points > 0) {
        let updatedCart = null;
        if (appliedDiscount.points > 0) {
          updatedCart = await updateCartAttribute(cart.id, [...cartAttributes,
            {
              key: 'pointsApplied',
              value: '0',
            },
            {
              key: 'numberOfPointsApplied',
              value: '0',
            }
          ]);
        }
        if (rebagCredit > 0 || walletCash > 0 || rewardsCredit > 0) {
          updatedCart = await handleCartGiftCards(cart.id, []);
        }
        dispatch({
          type: "UPDATE_SHOPIFY_CART",
          payload: {
            cart: updatedCart.cart,
            cartCount: filterLineItems(updatedCart.cart.lines).length
          }
        })
      } else {
        let updatedCart = {cart: null};
        const {user_gift_card_gfy_total, user_gift_card_total} = getState().myAccountReducer;
        const gfy_min_amount_to_apply = user_profile.gfy_min_dollar_amount;
        const should_show_gfy_error = user_gift_card_gfy_total > 0 && cart.cost.subtotalAmount.amount <= gfy_min_amount_to_apply && user_gift_card_gfy_total === user_gift_card_total;

        if (wallet.applyPoints) {
          updatedCart =  await updateCartAttribute(cart.id, [...cartAttributes,
            {
              key: 'pointsApplied',
              value: `${getState().myAccountReducer.user_profile.loyalty_points_value}`,
            },
            {
              key: 'numberOfPointsApplied',
              value: `${getState().myAccountReducer.user_profile.points}`,
            }
          ]);
        }
        let giftCardsToApply = [...rewards_gift_cards, ...wallet_gift_cards]
        if (should_show_gfy_error) {
          dispatch({
            type: "SET_GFY_ERROR",
            payload: true
          })
        } else {
          giftCardsToApply = [...giftCardsToApply, ...rebag_credit_gift_cards]
        }

        if (giftCardsToApply.length > 0) {
          updatedCart = await handleCartGiftCards(cart.id, giftCardsToApply);
        }

        if (updatedCart.cart) {
          dispatch({
            type: "UPDATE_SHOPIFY_CART",
            payload: {
              cart: updatedCart.cart,
              cartCount: updatedCart.cart ? filterLineItems(updatedCart.cart.lines).length : 0
            }
          })
        }
      }
    } catch (error) {
      appErrorLogger('Toggle Apply Wallet To Shopify Cart', error);
    } finally {
      dispatch({type: 'HIDE_CART_BUSY'});
    }
  }
}

export const removeShopifyCartRebagCreditGiftCards = () => async (dispatch, getState) => {
  const cart = getState().shopifyReducer.cart;
  const {rewards_gift_cards, wallet_gift_cards} = getState().myAccountReducer.user_profile;
  const updatedGiftCards = [...rewards_gift_cards, ...wallet_gift_cards].filter(giftCard => {
    const lastCharsGiftCard = giftCard.slice(-4);
    return cart.appliedGiftCards.find(appliedGiftCard => appliedGiftCard.lastCharacters === lastCharsGiftCard);
  });

  const updatedCart = await handleCartGiftCards(cart.id, updatedGiftCards);

  dispatch({
    type: "UPDATE_SHOPIFY_CART",
    payload: {
      cart: updatedCart.cart,
      cartCount: updatedCart.cart ? filterLineItems(updatedCart.cart.lines).length : 0
    }
  })
}

export const addShopifyCartRebagCreditGiftCards = () => async (dispatch, getState) => {
  const cart = getState().shopifyReducer.cart;
  const {rewards_gift_cards, wallet_gift_cards, rebag_credit_gift_cards, gfy_min_dollar_amount} = getState().myAccountReducer.user_profile;
  const {user_gift_card_gfy_total, user_gift_card_total} = getState().myAccountReducer;
  const should_show_gfy_error = user_gift_card_gfy_total > 0 && cart.cost.subtotalAmount.amount <= gfy_min_dollar_amount && user_gift_card_gfy_total === user_gift_card_total;
  if (should_show_gfy_error) {
    dispatch({
      type: "SET_GFY_ERROR",
      payload: true
    })
  } else {
    let updatedGiftCards = [...rewards_gift_cards, ...wallet_gift_cards].filter(giftCard => {
      const lastCharsGiftCard = giftCard.slice(-4);
      return cart.appliedGiftCards.find(appliedGiftCard => appliedGiftCard.lastCharacters === lastCharsGiftCard);
    });
    updatedGiftCards = [...updatedGiftCards, ...rebag_credit_gift_cards];
    if (updatedGiftCards.length > 0) {
      const updatedCart = await handleCartGiftCards(cart.id, updatedGiftCards);
      dispatch({
        type: "UPDATE_SHOPIFY_CART",
        payload: {
          cart: updatedCart.cart,
          cartCount: updatedCart.cart ? filterLineItems(updatedCart.cart.lines).length : 0
        }
      })
    }
  }
}

export const removeShopifyCartRewardsGiftCards = () => async (dispatch, getState) => {
  const cart = getState().shopifyReducer.cart;
  const {wallet_gift_cards, rebag_credit_gift_cards} = getState().myAccountReducer.user_profile;
  const updatedGiftCards = [...wallet_gift_cards, ...rebag_credit_gift_cards].filter(giftCard => {
    const lastCharsGiftCard = giftCard.slice(-4);
    return cart.appliedGiftCards.find(appliedGiftCard => appliedGiftCard.lastCharacters === lastCharsGiftCard);
  });

  const updatedCart = await handleCartGiftCards(cart.id, updatedGiftCards);

  dispatch({
    type: "UPDATE_SHOPIFY_CART",
    payload: {
      cart: updatedCart.cart,
      cartCount: updatedCart.cart ? filterLineItems(updatedCart.cart.lines).length : 0
    }
  })
}

export const addShopifyCartRewardsGiftCards = () => async (dispatch, getState) => {
  const cart = getState().shopifyReducer.cart;
  const {rewards_gift_cards, wallet_gift_cards, rebag_credit_gift_cards} = getState().myAccountReducer.user_profile;
  let updatedGiftCards = [...wallet_gift_cards, ...rebag_credit_gift_cards].filter(giftCard => {
    const lastCharsGiftCard = giftCard.slice(-4);
    return cart.appliedGiftCards.find(appliedGiftCard => appliedGiftCard.lastCharacters === lastCharsGiftCard);
  });
  updatedGiftCards = [...updatedGiftCards, ...rewards_gift_cards];
  const updatedCart = await handleCartGiftCards(cart.id, updatedGiftCards);

  dispatch({
    type: "UPDATE_SHOPIFY_CART",
    payload: {
      cart: updatedCart.cart,
      cartCount: updatedCart.cart ? filterLineItems(updatedCart.cart.lines).length : 0
    }
  })
}

export const removeShopifyCartSellerFundsGiftCards = () => async (dispatch, getState) => {
  const cart = getState().shopifyReducer.cart;
  const {rewards_gift_cards, rebag_credit_gift_cards} = getState().myAccountReducer.user_profile;
  const updatedGiftCards = [...rewards_gift_cards, ...rebag_credit_gift_cards].filter(giftCard => {
    const lastCharsGiftCard = giftCard.slice(-4);
    return cart.appliedGiftCards.find(appliedGiftCard => appliedGiftCard.lastCharacters === lastCharsGiftCard);
  });

  const updatedCart = await handleCartGiftCards(cart.id, updatedGiftCards);

  dispatch({
    type: "UPDATE_SHOPIFY_CART",
    payload: {
      cart: updatedCart.cart,
      cartCount: updatedCart.cart ? filterLineItems(updatedCart.cart.lines).length : 0
    }
  })
}

export const addShopifyCartSellerFundsGiftCards = () => async (dispatch, getState) => {
  const cart = getState().shopifyReducer.cart;
  const {rewards_gift_cards, wallet_gift_cards, rebag_credit_gift_cards} = getState().myAccountReducer.user_profile;
  let updatedGiftCards = [...rewards_gift_cards, ...rebag_credit_gift_cards].filter(giftCard => {
    const lastCharsGiftCard = giftCard.slice(-4);
    return cart.appliedGiftCards.find(appliedGiftCard => appliedGiftCard.lastCharacters === lastCharsGiftCard);
  });
  updatedGiftCards = [...updatedGiftCards, ...wallet_gift_cards];
  const updatedCart = await handleCartGiftCards(cart.id, updatedGiftCards);

  dispatch({
    type: "UPDATE_SHOPIFY_CART",
    payload: {
      cart: updatedCart.cart,
      cartCount: updatedCart.cart ? filterLineItems(updatedCart.cart.lines).length : 0
    }
  })
}

export const goToCheckoutWithMultipass = (checkout_url, customerData) => {
  const multipass = new Multipass(config.storefront_api.secret_key);
  const url = multipass.withCustomerData(customerData)
    .withDomain(config.storefront_api.domain)
    .withRedirect(checkout_url)
    .url();
  window.location.href = url;
}

export const getCartAndRedirectToCheckout = (email) => async (dispatch) => {
  return new Promise (async (resolve) => {
    const alternatePaymentFlow = getCookie('alternatePaymentSubscription');
    if (alternatePaymentFlow) {
      dispatch(showSpinner());
      const userLastCart = await getUserLastCart();
      const cartId = userLastCart.storefront_id;
      setCookie('cart', cartId.replace('gid://shopify/Cart/', ''));
      deleteCookie('alternatePaymentSubscription');
      dispatch(continueToShopifyCheckout(email, cartId));
    } else {
      resolve();
    }
  })
}

export const getShopifyCart = (cartId) => {
  return new Promise(async (resolve) => {
    try {
      if (cartId) {
        const cartObject = await storefrontApi(getCartQuery, {cartId});
        const formattedCart = formatShopifyCart(cartObject.data.cart, cartObject.data.userErrors);
        resolve(formattedCart);
      } else {
        resolve({cart: null, userErrors: null});
      }
    } catch (error) {
      appErrorLogger('getShopifyCart', error);
      resolve({cart: null, userErrors: null});
    }
  })
}

export const alternatePaymentFlow = async (cart, shippingProtectionItem) => {
  const defaultSubscription = config.subscriptions.default;
  const subscriptionLineItem = cart.lines.find(lineItem => lineItem.merchandise.id === defaultSubscription.merchandiseId);
  await removeCartLineItems([subscriptionLineItem.id], cart.id);
  if (shippingProtectionItem) {
    await addCartLineItems([shippingProtectionItem.shopifyObject], cart.id);
  }
  setCookie('alternatePaymentSubscription', 'true');
  await createSubscriptionOnlyCart(defaultSubscription, 'alternatePaymentSubscription');
}

export const createSubscriptionOnlyCart = async (subscription, cartNote) => {
  delete subscription.amount;
  const cartLineItems = [subscription];
  const multipass = new Multipass(config.storefront_api.secret_key);
  const customerData = {
    email: getCookie('auth_email'),
    user: getCookie('auth_token'),
  };
  const attributes = [
    {
      key: 'tradeTaxAdjustment',
      value: '0',
    },
    {
      key: 'apiHost',
      value: config.host_rebag_api
    },
    {
      key: 'tradesApplied',
      value: '0',
    },
    {
      key: 'pointsApplied',
      value: '0',
    },
    {
      key: 'numberOfPointsApplied',
      value: '0',
    },
    {
      key: 'checkout_type',
      value: 'web'
    }
  ]
  if (window._pp && window._pp.ppid) {
    attributes.push(
      {
        key: 'ppid',
        value: `${window._pp.ppid}`
      },
    )
  }

  if (cartNote === 'alternatePaymentSubscription') {
    attributes.push({
      key: 'rPlusAlternate',
      value: 'true'
    })
  } if (cartNote === 'subscriptionOnlySellFlow') {
    attributes.push({
      key: 'rPlusSellFlow',
      value: 'true'
    })
  } if (cartNote === 'subscriptionOnlySellFlowReminder') {
    attributes.push({
      key: 'rPlusSellFlowReminder',
      value: 'true'
    })
  } else {
    attributes.push({
      key: 'rPlus',
      value: 'true'
    })
  }

  try {
    const cartResponse = await createCart(cartLineItems, cartNote, attributes);
    const redirect_after_url = cartResponse.cart.checkoutUrl;
    const url = multipass.withCustomerData(customerData)
      .withDomain(config.storefront_api.domain)
      .withRedirect(redirect_after_url)
      .url();
    window.location.href = url;
  } catch (error) {
    appErrorLogger('createSubscriptionOnlyCart', error);
  }
}

export const getOrCreateShopifyCart = (user_profile) => {
  return new Promise (async (resolve) => {
    const userLastCart = await getUserLastCart();
    if (userLastCart) {
      resolve(userLastCart);
    } else {
      const cartSubscription = [config.subscriptions.default];
      const cartResponse = await createCart(cartSubscription,'withSubscription', defaultCartAttributes, user_profile);
      await saveUserLastCart({
        storefront_id: cartResponse.cart.id,
        checkout_url: cartResponse.cart.checkoutUrl
      })
      resolve(cartResponse.cart);
    }
  })

}

export const getUserLastCart = () => {
  return new Promise ((resolve) => {
    if (authCheck()) {
      setAxiosInstance().get(`${config.host_rebag_api}/v6/last-cart/`, { withCredentials: true }).then(response => {
          resolve(response.data);
          setCookie('shopify_cart_id', response.data.id);
        }
      ).catch(() => resolve(null));
    } else {
      resolve(null);
    }
  })
}

export const saveUserLastCart = (data) => {
  if (authCheck()) {
    return setAxiosInstance().post(`${config.host_rebag_api}/v6/last-cart/`, data, { withCredentials: true });
  }
}

export const mergeShopifyCartItems = () => (dispatch, getState) => {
  return new Promise (async (resolve) => {
    const localCart = getState().shopifyReducer.cart;
    const localCartLines = localCart ? localCart.lines.filter(line => !isCartLineItemSubscription(line)) : [];
    const user_profile = getState().myAccountReducer.user_profile;
    const backendUserCart = await getUserLastCart();

    try {
      if (backendUserCart) {
        const shopifyCartObject = await getShopifyCart(backendUserCart.storefront_id);
        const shopifyCartLines = shopifyCartObject.cart.lines;
        setCookie('cartId', backendUserCart.storefront_id);
        if (localCartLines.length > 0) {
          const lineItemsToAdd = localCartLines.map(line => {
            if (!shopifyCartLines.find(shopifyLine => shopifyLine.merchandise.id === line.merchandise.id)) {
              return {
                merchandiseId: line.merchandise.id,
                quantity: 1,
              }
            }
          })
          const userIsRPlus = isRPlusMembershipActive(user_profile);
          if (userIsRPlus) {
            const updatedCart = await addCartLineItems(lineItemsToAdd, shopifyCartObject.cart.id);
            dispatch({
              type: "UPDATE_SHOPIFY_CART",
              payload: {
                cart: updatedCart.cart,
                cartCount: filterLineItems(updatedCart.cart.lines).length
              }
            })
          } else {
            lineItemsToAdd.push(config.subscriptions.default);
            const updatedCart = await addCartLineItems(lineItemsToAdd, shopifyCartObject.cart.id);
            const updatedCartNote = await updateCartNote('withSubscription', shopifyCartObject.cart.id);

            dispatch({
              type: "UPDATE_SHOPIFY_CART",
              payload: {
                cart: {...updatedCart.cart, note: updatedCartNote.data.cartNoteUpdate.cart.note},
                cartCount: filterLineItems(updatedCart.cart.lines).length
              }
            })
            dispatch({
              type: 'TOGGLE_CART',
              payload: true
            })
          }
        }
      } else {
        await saveUserLastCart({
          storefront_id: localCart.id,
          checkout_url: localCart.checkoutUrl
        })
        dispatch({
          type: 'TOGGLE_CART',
          payload: true
        })
      }
    } catch (error) {
      appErrorLogger('Merge Shopify Cart Items', error);
    } finally {
      resolve();
    }
  })
}

export const getLocalCartId = () => {
  return getCookie('cartId');
}

export const setWalletAccordion = (payload) => dispatch => {
  dispatch({
    type: 'SET_WALLET_OPEN_ACCORDION',
    payload
  })
}

export const updateCartAttribute = (cartId, attributes) => {
  return new Promise(async (resolve) => {
    const variables = {
      "attributes": attributes,
      "cartId": cartId
    }
    if (!cartId) {
      resolve({cart: null, userErrors: null});
      return;
    }
    try {
      const updateCartAttributesResponse = await storefrontApi(updateCartAttributesMutation, variables);
      const formattedCart = formatShopifyCart(updateCartAttributesResponse.data.cartAttributesUpdate.cart, updateCartAttributesResponse.data.cartAttributesUpdate.userErrors);
      resolve(formattedCart);
    } catch (error) {
      appErrorLogger('updateCartAttribute', error);
      resolve({cart: null, userErrors: null});
    }
  })
}

export const updateCartNote = (note, cartId) => {
  return new Promise(async (resolve) => {
    const variables = {
      cartId,
      note
    }
    try {
      const updateCheckoutAttributesResponse = await storefrontApi(updateCartNoteMutation, variables);
      resolve(updateCheckoutAttributesResponse);
    } catch (error) {
      appErrorLogger('updateCartNote', error);
      resolve();
    }
  })
}
